"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payments = void 0;
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function Invoices(_a) {
    var records = _a.records, label = _a.label, empty = _a.empty;
    return react_1.default.createElement(storybook_1.Cards.Card, null,
        react_1.default.createElement(storybook_1.Lists.Header, null,
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4' }, label)),
        react_1.default.createElement(storybook_1.Lists.List, null,
            react_1.default.createElement("div", { className: 'my-4' },
                Boolean(records.length) && react_1.default.createElement(storybook_1.Buttons.Group, null, records.map(function (record, key) {
                    return react_1.default.createElement(storybook_1.Buttons.Download, { key: key, icon: 'paper-clip-solid', label: 'Factuur', href: record.download }, record.description);
                })),
                !Boolean(records.length) && react_1.default.createElement(storybook_1.Forms.New, { description: empty }))));
}
function channelOrders(channel) {
    if (channel.id) {
        return ra_fetch_1.useApi('ecommerce').index('orders', {
            channel_id: channel.id,
            sort: 'updated_at desc',
            status: 'paid',
            orderable_type: 'subscriptions'
        });
    }
    return [__assign(__assign({}, ra_fetch_1.Fetcher.collection()), { loading: false })];
}
var Payments = function (_a) {
    var user = _a.user, channel = _a.channel;
    var orders = ra_fetch_1.useApi('ecommerce').index('orders', {
        user_id: user.id,
        sort: 'updated_at desc',
        status: 'paid',
    })[0];
    var channel_orders = channelOrders(channel)[0];
    if (orders.loading || channel_orders.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    var pay_per_views = orders.data.filter(function (order) { return order.type === 'videos'; });
    var subscriptions = orders.data.filter(function (order) { return order.type === 'subscriptions'; });
    return react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'storybook-layouts-space' },
        react_1.default.createElement(storybook_1.Texts.Heading, { appendClassname: 'text-center mb-4' }, "Mijn aankopen"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'gap-8 flex flex-col' },
                react_1.default.createElement(Invoices, { records: pay_per_views, label: 'Facturen pay-per-view', empty: 'Je hebt nog geen aankopen gedaan op Eyecons.' }),
                react_1.default.createElement(Invoices, { records: subscriptions, label: 'Facturen abonnementen', empty: 'Je hebt nog geen abonnement op Eyecons.' }),
                Boolean(channel.id) && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Invoices, { records: channel_orders.data, label: 'Facturen Eyecons PRO', empty: 'Je hebt met geen van je kanalen een abonnement op Eyecons PRO' })))));
};
exports.Payments = Payments;
